import React, { Component } from "react";
import PropTypes from "prop-types";

import "./Notifications.scss";
import NotificationsList from "./NotificationsList";

class Notifications extends Component {
  static propTypes = {
    getMoreNotifications: PropTypes.func,
    notifications: PropTypes.array,
    onClickOutside: PropTypes.func,
    onNotificationClick: PropTypes.func 
  };

  static defaultProps = {
    getMoreNotifications: () => {},
    notifications: [],
    onClickOutside: ()=> {},
    onNotificationClick: ()=> {} 
  };

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const { notifications, getMoreNotifications, onClickOutside, onNotificationClick } = this.props;

    return (
      <NotificationsList
        notifications={notifications}
        getMoreNotifications={getMoreNotifications}
        onNotificationClick={onNotificationClick}
        onClickOutside={onClickOutside}
      />
    );
  }
}

export default Notifications;
